import { useMutation } from '@apollo/client';
import DELETE_USER_CONTENT_SHARE from 'graphql/mutations/userContentShares/DeleteUserContentShare.graphql';

export default function useDeleteUserContentShareMutation() {
  return useMutation(DELETE_USER_CONTENT_SHARE);
}
